
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(1706|35447|55745)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
